import React, { useState } from "react";
import siteManagementService from "../../../services/SiteManagementService";
import LocationForm from "../Forms/LocationForm";
import LoginPicklistItemForm from "../Forms/LoginPicklistItemForm";
import FormModal, {
  ModalMessageSettings,
  getResultMessage,
} from "../../Common/FormModal";
import { LPLItemDTO, LocationDTO } from "@beable/roster-backend-client-v1";

interface AddModalProps {
  open: boolean;
  handleClose: any;
  addingLocation: boolean;
  parentLocations: LocationDTO[];
  locations: LocationDTO[];
}

export default function AddModal({ addingLocation, ...props }: AddModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();

  const submitLocationForm = async (
    name: string,
    isoCode: string,
    parentId: number,
    _id?: number,
    _hasChildren?: boolean
  ) => {
    const locationPayload: LocationDTO = {
      id: -1,
      name: name.trim(),
      isoCode: isoCode.trim(),
      parentId: parentId,
      hasChildren: false,
    };
    setIsLoading(true);
    const result = await siteManagementService.addNewLocation(locationPayload);
    const message = getResultMessage(
      result,
      `Location added successfully!`,
      `Failed to add this location!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const submitSiteForm = async (
    name: string,
    purl: string,
    stateName: string,
    _id?: string
  ) => {
    const sitePayload: LPLItemDTO = {
      id: "-1",
      name: name.trim(),
      leaid: '',
      siteName: purl,
      state: stateName,
    };
    setIsLoading(true);
    const result = await siteManagementService.addNewLPLItem(sitePayload);
    const message = getResultMessage(
      result,
      `Site added successfully!`,
      `Failed to add this site!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title={`Add new ${addingLocation ? "location" : "site"}`}
      description={
        addingLocation
          ? "Adds a new location to be used by sites."
          : "Adds a new site to be used for user logins."
      }
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      {addingLocation ? (
        <LocationForm
          parentLocations={props.parentLocations}
          submitForm={submitLocationForm}
          onClose={handleClose}
        />
      ) : (
        <LoginPicklistItemForm
          locations={props.locations}
          submitForm={submitSiteForm}
          onClose={handleClose}
        />
      )}
    </FormModal>
  );
}